<template>
  <div>
    <div class="service-type base-info">
      <div class="title-mode">物流信息</div>
      <div class="xinxi">
        <div class="tabclass duan">
          <span class="label">物流位置：</span>
          <i
            >{{ orderInfo.isArrival ? "已到货" : "未到货"
            }}<span v-if="orderInfo.orderType == 'TIMELY'"
              >（{{
                orderInfo.orderExpand.isJishiTihuoFei
                  ? "已到提货点"
                  : "已到客户家"
              }}）</span
            ></i
          >
        </div>
        <div class="tabclass duan">
          <span class="label">物流公司：</span>
          <i>{{ orderInfo.logisticsName || "/" }}</i>
        </div>
        <div class="tabclass duan">
          <span class="label">物流单号：</span>
          <i>{{ orderInfo.logisticsNo || "/" }}</i>
        </div>
        <div class="tabclass duan">
          <span class="label">物流电话：</span>
          <i>{{
            !orderInfo.logisticsPhone ? "/" : orderInfo.logisticsPhone
          }}</i>
        </div>
        <div class="tabclass duan">
          <span class="label">提货码：</span>
          <i>{{ orderInfo.pickupCode || "/" }}</i>
        </div>
        <div class="tabclass chang">
          <span class="label">提货地址：</span>
          <i>{{ orderInfo.pickupAddress || "/" }}</i>
          <!-- <i>{{orderInfo.pickupAreaName?orderInfo.pickupAreaName+' ':''}}{{ orderInfo.pickupAddress || "/" }}</i> -->
        </div>
      </div>
    </div>
    <map-view
      ref="mapView"
      :orderInfo="orderInfo"
    ></map-view>
    <div class="service-type base-info">
      <div class="title-mode">跟踪记录</div>
      <div class="logistics_main" v-if="logisticsList.length">
        <div class="logistics_record" v-for="item in logisticsList">
          <div class="left_time">
            {{ new Date(item.time).format("yyyy-MM-dd") }}/周{{
              setWhichDay(item.time)
            }}
          </div>
          <div class="content">
            <div v-for="it in item.list">
              {{ new Date(it.time).format("HH:mm:ss") }}
              <div class="text">{{ it.context }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="null-info" v-if="!logisticsList.length">
        <img src="@/assets/img/pic_none.png" alt />
        暂无信息...
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import mapView from "./mapView";

export default {
  components: {
    mapView,
  },
  data() {
    return {
      url: {
        list: "/common/api/wuliu/query_by_kuaidinum",
      },
      logisticsList: [],
      logisticsData: {},
      wuliuMessage: {
        data: [],
      },
      orderInfo: {
        orderExpand: {},
      },
    };
  },

  methods: {
    // 加载地图
    setMap() {
      this.$nextTick(() => {
        this.$refs.mapView.setMap();
      });
    },
    loadData() {
      getAction(this.url.list, {
        // kuaidiNum: this.orderInfo.logisticsNo || "YT6015680394322",
        kuaidiNum: this.orderInfo.logisticsNo,
      }).then(({ data }) => {
        console.log(data);
        if (data.code == 0 && data.data) {
          this.logisticsData = data.data;
          if (data.data && data.data.wuliuMessage) {
            this.wuliuMessage = JSON.parse(data.data.wuliuMessage);
            this.logisticsList = this.sortByMonth(this.wuliuMessage.data);
          }
        } else {
          this.logisticsList = [];
          this.logisticsDat = {};
          this.wuliuMessage = {
            data: [],
          };
        }
      });
    },
    // 数据处理
    sortByMonth(arr) {
      let resultObj = {};
      let resultArr = [];
      for (let i of arr) {
        let startTime = i.time;
        startTime = new Date(startTime).format("yyyy-MM-dd");
        if (!resultObj[startTime]) {
          resultObj[startTime] = [];
        }
        resultObj[startTime].push(i);
      }
      for (let j in resultObj) {
        resultArr.push({
          list: resultObj[j],
          time: j,
        });
      }
      return resultArr;
    },
    setWhichDay(date) {
      return this.setNumText(new Date(date).getDay());
    },
    // 数字替换为汉字
    setNumText(num) {
      if (num == 1) return "一";
      if (num == 2) return "二";
      if (num == 3) return "三";
      if (num == 4) return "四";
      if (num == 5) return "五";
      if (num == 6) return "六";
      if (num == 0) return "日";
    },
  },
};
</script>

<style lang='scss' scoped>
.logistics_record {
  display: flex;
  justify-content: space-between;
  color: #5e6066;
  font-size: 12px;
  padding-top: 16px;
  &:first-child {
    padding-top: 0;
  }
  .content {
    width: 900px;
    & > div {
      display: flex;
      margin-top: 16px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 5px;
        height: 5px;
        background: #dcdfe6;
        border-radius: 50%;
        left: -30px;
        top: 8px;
      }
      &::after {
        content: "";
        position: absolute;
        height: calc(100% + 16px);
        width: 1px;
        background: #dcdfe6;
        left: -28px;
        top: 8px;
      }
      &:first-child {
        margin-top: 0;
      }
      .text {
        line-height: 16px;
        margin-left: 24px;
        width: 820px;
      }
    }
  }
  &:last-child {
    .content {
      & > div:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
  .left_time {
    width: 125px;
  }
}
.logistics_main {
  padding: 18px 20px;
  background: #fff;
}
.service-type {
  margin-top: 10px;
}
.base-info {
  .service-type {
    display: flex;
  }
  .xinxi {
    display: flex;
    flex-wrap: wrap;
    padding-right: 0;
    i {
      font-style: normal;
      line-height: 18px;
    }
  }
  .label {
    line-height: 18px;
    width: auto !important;
  }
  .duan {
    width: 211px;
    i {
      width: 151px;
      line-height: 18px;
    }
  }
  .zhong {
    width: 270px;
    i {
      width: 210px;
    }
  }
  .chang {
    width: 1065px;
    i {
      width: 990px;
    }
  }
}
.title-mode {
  border-radius: 2px;
  color: #5e6066;
  font-size: 14px;
  line-height: 14px;
  padding: 10px 16px;
  background: #f9fafa;
}
.null-info {
  background: #fff;
  padding: 30px 261px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #b4b7bc;
  // margin-top: 15px;

  img {
    width: 375px;
    height: 94px;
    margin-bottom: 8px;
  }
}
</style>
